import { useMutation, useQueryClient } from '@tanstack/react-query';

import { disableMfa } from '../api/adminsApi';
import { ADMIN_ACCOUNTS_QUERY_KEY } from './useAdminAccounts';

// PARA-151, AC-6: отключение своей MFA. После 200 сессия отозвана (AC-9) —
// обработка успеха (logout + редирект на /login) живёт в DisableMfaModal.
export function useMfaDisable() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (totpCode: string) => disableMfa(totpCode),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: ADMIN_ACCOUNTS_QUERY_KEY });
    },
  });
}
